import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassPlay } from '@/fontawesome';
import Modal from '@/components/ui/Modal';
import { useVideoFinder } from '@/contexts/VideoFinderContext';
import VideoFinderPanel from '@/components/video-finder/VideoFinderPanel';

/**
 * Dauerhaft gemounteter Wrapper um das Video-Finder-Panel.
 *
 * Der State liegt bewusst im VideoFinderProvider, nicht hier - die Modal-Komponente unmountet
 * ihre Kinder beim Schließen, die laufende Suche würde das sonst nicht überleben.
 */
export default function VideoFinderModal() {
  const { isOpen, isAvailable, close } = useVideoFinder();

  return (
    <Modal
      isOpen={isOpen && isAvailable}
      onClose={close}
      title="Video-Finder"
      icon={<FontAwesomeIcon icon={faMagnifyingGlassPlay} className="w-5 h-5 text-blue-600 dark:text-blue-400" />}
      maxWidth="5xl"
      // dvh statt vh, damit der Composer sichtbar bleibt, wenn auf Android die Tastatur aufgeht.
      // Muss zur Wurzelhöhe im Panel passen: h-[calc(90dvh-100px)].
      maxHeight="90dvh"
      closeOnEscape
      closeOnBackdropClick
    >
      <VideoFinderPanel />
    </Modal>
  );
}
